import { Formik, Form } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Yup from "yup";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import "./Sign-In.css";
import { axiosInstance } from "../../utils/axios-instance";
import { SignInSubmission } from "./Sign-In-Submission";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { fetchSignIn } from "../../store/thunks/fetch-sign-in-thunk";
import { selectSignIn } from "../../store/slices/signed-in-slice";
import { fetchProfile } from "../../store/thunks/fetch-profile-thunk";
import { fetchApplication } from "../../store/thunks/fetch-application-thunk";
import { fetchIndividualAssessments } from "../../store/thunks/fetch-individual-assessments-thunk";
import { FormikOnError } from "../Custom-Forms/Formik-On-Error";

import {toast} from 'react-toastify';



export const SignIn = () => {
    const formikRef = useRef();
    const ToastID = React.useRef(null)
    let response;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isSignedIn = useSelector(selectSignIn);

    const [searchParams] = useSearchParams();

    // 429, too many requests error
    const [is429Error, setIs429Error] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);

    const [showPassword, setShowPassword] = useState(false);

    const verified = searchParams.get("verified")

    const formatTime = (t) => (t < 10 ? "0" + t : t);

    useEffect(() => {
        if (timeLeft <= 0 && is429Error) {
            setIs429Error(false);
            formikRef.current?.resetForm();
        }

        if (timeLeft <= 0) {
            return;
        }

        // if (is429Error) {
        const myInterval = setInterval(() => {
            // const minutes = Math.floor(timeLeft / 60);
            // // if (timeLeft <= 0) clearInterval(interval);
            
            setTimeLeft((t) => t - 1);
            // if (minutes <= 0 && timeLeft <= 1) {
            //     setIs429Error(false);
            //     formikRef.current?.resetForm();
            // }

            return () => clearInterval(myInterval);
        }, 1000);
        return () => clearInterval(myInterval);
        // }
        // else {
        //     setIs429Error(false);
        //     clearInterval(myInterval.current);
        //     myInterval.current = null;
        // }
    }, [timeLeft]);

    // If user is signed in,
    // redirect to the home page
    useEffect(() => {
        if (isSignedIn) {
            navigate("/");
        }
    }, []);

    const signInValidationSchema = Yup.object({
        email: Yup.string().email("Invalid Email address").required("Email is required"),
        password: Yup.string().required("Password is required"),
    });

    
    return (
        <>
            {/* <ToastContainer position="top-center" containerId={'sign-in'}/> */}
            <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                <Row>
                    <Col className="justify-content-start d-flex align-item-center">
                        <h1>Sign In Page</h1>
                    </Col>
                    <Col className="justify-content-end d-flex align-item-center">
                        {verified && (
                            <h3 className="text-success">Your account has been verified.</h3>
                        )}
                    </Col>
                </Row>
                <Row className="card-background card-font">
                    <Formik
                        innerRef={formikRef}
                        initialValues={{
                            email: "",
                            password: "",
                        }}
                        validationSchema={signInValidationSchema}
                        onSubmit={async (values, { setStatus }) => {
                            try {
                                ToastID.current = toast.loading(`Attempting to Sign In`, {theme: "colored", containerId:"root", autoClose: "5000"} )
                                response = await axiosInstance({
                                    method: "post",
                                    url: "/sign-in",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    data: {
                                        email: values.email,
                                        password: values.password,
                                    },
                                });

                                // toast.success(`Successfully Signed In`, {theme: "colored", autoClose: "5000"}, )
                                toast.update(ToastID.current , {render: `Successfully Signed In`, type: "success", isLoading: false, theme: "colored", autoClose: "3500",  containerId:"root"} )
                                // If successful sign-in but the user does not have a verified phone
                                // Generate a code and redirect to unique page to verify it
                                // if (response?.data.status === 0 && response?.data.message === "Error phone") {
                                //     navigate(
                                //         `/verify-phone?client_id=${response.data.data}&type=signin`
                                //     );
                                //     return Promise.reject();
                                // }
                                

                                const accessToken = response.data.data;
                                localStorage.setItem(
                                    "accessToken",
                                    accessToken,
                                );

                                navigate("/") 

                                setStatus({ error: false });
                                // Update signed in status
                                dispatch(fetchSignIn());

                                // fetch the users profile and then go to profile page
                                dispatch(fetchProfile())
                                    .then(() => {
                                        dispatch(fetchApplication());
                                    })
                                    .then(() => {
                                        dispatch(fetchIndividualAssessments())
                                    })
                                    .catch(() => {
                                        navigate("/");
                                    });
                            } catch (err) {
                                // If successful sign-in but the users account is not verified
                                // redirect to verify email page
                                if (err?.response.data.status === 5 && err?.response.data.message === "Profile Not Verified") {
                                    toast.update(ToastID.current , {render: `Profile Not Verified`, type: "warning", isLoading: false, theme: "colored", autoClose: "5000",  containerId:"root"})
                                    navigate(
                                        `/request-account-verification?email=${values.email}`
                                    );
                                }

                                const errCode = err?.request?.status;
                                // If 429, too many requests then set the 429 error and time left
                                if (errCode === 429) {
                                    setTimeLeft(
                                        err?.response?.data &&
                                        Number(err?.response?.data),
                                    );
                                    setIs429Error(true);
                                    toast.update(ToastID.current , {render: `Too many failed attempts. Try Again Later.`, type: "error", isLoading: false, theme: "colored", autoClose: "5000",  containerId:"root"})
                                } else {
                                    setStatus({ error: true });
                                    toast.update(ToastID.current , {render: `Failed to Signed In`, type: "error", isLoading: false, theme: "colored", autoClose: "5000", containerId:"root"})
                                }
                            }
                        }}
                    >
                        <Form>
                            <FormikOnError>
                                <Row className="mx-0">
                                    <Col>
                                        <GeneralTextAreaField
                                            autoFocus
                                            label="Email Address:"
                                            className="form-control"
                                            component="input"
                                            name="email"
                                            rows="1"
                                            placeholder="Enter Your Email Address"
                                            autoComplete="email"
                                            aria-required="true"
                                            aria-label="Email Address field"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mx-0 mb-2">
                                    <Col>
                                        <GeneralTextAreaField
                                            label="Password:"
                                            className="form-control"
                                            name="password"
                                            type={
                                                showPassword ? "text" : "password"
                                            }
                                            component="input"
                                            rows="1"
                                            placeholder="Enter Your Password"
                                            autoComplete="current-password"
                                            aria-required="true"
                                            aria-label="Password field"
                                        />
                                    </Col>
                                </Row>
                                {is429Error && (
                                    <p role="status" className="text-danger">
                                        Too Many Wrong Attempts, Retry after{" "}
                                        {Math.floor(timeLeft / 60)} minute(s){" "}
                                    </p>
                                )}
                                {!is429Error && <SignInSubmission props={{ showPassword, setShowPassword }} />}
                            </FormikOnError>
                        </Form>
                    </Formik>
                </Row>
            </Container>
        </>
    );
};
